// import

import {styled} from 'goober';
import type {HTMLAttributes} from 'react';
import {useRef} from 'react';
import {TransitionGroup, CSSTransition} from 'react-transition-group';

import {Message} from './Message';
import {useMessageList} from './useMessageList';

// types

type Props = HTMLAttributes<HTMLElement>;

// component

export function MessageList(props: Props) {
  const {className, ...rest} = props;
  const list = useMessageList();
  const refs = useRef({});

  return (
    <Block {...rest}>
      <TransitionGroup component={null}>
        {list.map((msg) => {
          // eslint-disable-next-line no-multi-assign
          const nodeRef = refs.current[msg.key] ??= {current: null};

          return (
            <CSSTransition
              key={msg.key}
              nodeRef={nodeRef}
              timeout={250}
            >
              <Message
                className="message"
                forwardRef={nodeRef}
                message={msg}
              />
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </Block>
  );
}

// styles

const Block = styled('aside')`
  position: fixed;
  top: var(--layout-header-height);
  right: 0;
  bottom: 0;
  padding: 1.5rem;
  width: var(--bp-xs);
  user-select: none;
  pointer-events: none;
  z-index: var(--z-messages);

  .message {
    margin-bottom: 1rem;
  }
`;
